module.exports = __webpack_public_path__ + "static/media/celer.13649fb3.png";